/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Column } from 'uikit/grids';
import ProfileCredentialsListItem from './profileCredentialsListItem';

// import styles from '../styles/profileCredentialsList.module.scss';

const ProfileCredentialsList = ({
  credentials = [],
  isCurrentUser = false,
  isMyLearning = false,
  onCredentialClick = () => {},
}) => (
  <Grid>
    <Row sizes={{ default: 1, medium: 2, large: isMyLearning ? 2 : 3 }}>
      {credentials.map((credential, index) => (
        <Column key={index}>
          <ProfileCredentialsListItem
            credential={credential}
            isCurrentUser={isCurrentUser}
            onCredentialClick={onCredentialClick}
          />
        </Column>
      ))}
    </Row>
  </Grid>
);

ProfileCredentialsList.propTypes = {
  credentials: PropTypes.arrayOf(PropTypes.shape({})),
  isCurrentUser: PropTypes.bool,
  isMyLearning: PropTypes.bool,
  onCredentialClick: PropTypes.func,
};

export default React.memo(ProfileCredentialsList);
